import { defineMessages } from 'react-intl'

export const SUBSCRIPTIONS = defineMessages({
  DAILY: {
    id: 'djcity.billing.subscription.plans.daily',
    defaultMessage: 'DAILY',
  },
  MONTHLY: {
    id: 'djcity.billing.subscription.plans.monthly',
    defaultMessage: 'MONTHLY',
  },
  QUARTERLY: {
    id: 'djcity.billing.subscription.plans.quarterly',
    defaultMessage: 'QUARTERLY',
  },
  BIANNUALLY: {
    id: 'djcity.billing.subscription.plans.biannually',
    defaultMessage: 'BIANNUALLY',
  },
  ANNUALLY: {
    id: 'djcity.billing.subscription.plans.annually',
    defaultMessage: 'ANNUALLY',
  },
})

export const PROMOS = defineMessages({
  ALL: {
    id: 'djcity.billing.subscription.plans.promos',
    defaultMessage: 'PROMO',
  },
})
